export const LPPOLICE = "lppolice";
export const LOCATEPLUS = "locateplus";
export const ENTERSECT = "entersect";

export const LPPOLICE_TITLE =
  "LpPolice | Investigative Database | Skip Tracing Tools";
export const LOCATEPLUS_TITLE =
  "LocatePLUS | Investigative Database | Skip Tracing Tools";
export const ENTERSECT_TITLE =
  "Entersect | Investigative Database | Skip Tracing Tools";



// WEBPACK FOOTER //
// ./src/components/pages/Const.js